export default {
	AT: 'https://gkcl-at.generaliceska.cz',
	ST: 'https://gkcl-st.generaliceska.cz',
	ST4: 'https://gkcl-st4.generaliceska.cz',
	PREP: 'https://gkcl-prep.generaliceska.cz',
	PROD: 'https://gkcl.generaliceska.cz',
};
